import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedPipesModule } from '../../../../../shared/pipes/shared-pipes.module';
import { TitleRegistrationService } from '../../../../services/titleregistration.service';
import { TitleHistoryModalComponent } from './title-history-modal.component';

@NgModule({
    declarations: [
        TitleHistoryModalComponent
    ],
    providers: [
        TitleRegistrationService
    ],
    imports: [
        CommonModule,
        SharedPipesModule,
    ]
})
export class TitleHistoryModalModule {
}
